import { put, call } from 'redux-saga/effects'

import { BFFAgent } from '../../../../common/BFFAgent'
import {
  COMMISSIONS_GET_PERIOD_SUCCESS,
  COMMISSIONS_GET_PERIOD_FAILURE
} from '../constants'

export function* getCommissionsPeriodsSaga() {
  try {
      const state =  yield call(BFFAgent.Commission.getCommissionsPeriods)

      yield put({
          type: COMMISSIONS_GET_PERIOD_SUCCESS,
          data: state
      })
      
  } catch (error) {
    yield put({
      type: COMMISSIONS_GET_PERIOD_FAILURE,
      data: { error }
    })
  }
}